/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceSupportTicketListResponse {
    getFixupPrototypeFunction() { return FreshserviceSupportTicketListResponse.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceSupportTicketListResponse>): FreshserviceSupportTicketListResponse {
        let obj = Object.assign(new FreshserviceSupportTicketListResponse(), model);
        FreshserviceSupportTicketListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceSupportTicketListResponse>): FreshserviceSupportTicketListResponse {
        if (!model) return null;
        return FreshserviceSupportTicketListResponse.newInstance(<FreshserviceSupportTicketListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceSupportTicketListResponse) {
        if (!obj) return;

        models.FreshserviceSupportTicketListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceSupportTicketListResponse): boolean {
        Object.setPrototypeOf(obj, FreshserviceSupportTicketListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.FreshserviceTicketDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Tickets List
     */
    results: Array<models.FreshserviceTicketDetails>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
